import {createLazyResourceTableUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {AnswerModel} from '../../../models/api/answerModel';
import {AppAction} from '../../appActions';
import {deleteFromResourceTable, LazyResourceTable, ResourceTableStatusesEnum} from '../../appTypes';
import {AnswerActionsEnum} from './answerActions';

const answersUpdatedReducer = createLazyResourceTableUpdatedReducer('answers', (answer) => answer.id);

export function answersReducer(
  state: LazyResourceTable<number, AnswerModel>,
  action: AppAction,
): LazyResourceTable<number, AnswerModel> {
  switch (action.type) {
    case AnswerActionsEnum.ANSWER_UPDATED:
      return answersUpdatedReducer(state, {
        ...action,
        payload: {
          result: {
            answers: [action.payload],
          },
        },
      });

    case AnswerActionsEnum.ANSWER_DELETED:
    case AnswerActionsEnum.ANSWERS_DELETED:
      return deleteFromResourceTable(state, action.payload);

    case AnswerActionsEnum.FETCH_ANSWERS:
      return {
        ...state,
        status: ResourceTableStatusesEnum.LOADING,
        error: undefined,
      };

    case AnswerActionsEnum.FETCH_ANSWERS_FAILED:
      return {
        ...state,
        status: ResourceTableStatusesEnum.FAILED,
        error: action.payload,
      };

    case AnswerActionsEnum.FETCH_ANSWERS_COMPLETED:
      return {
        ...answersUpdatedReducer(state, {
          ...action,
          payload: {
            result: {
              answers: action.payload,
            },
          },
        }),
        status: ResourceTableStatusesEnum.LOADED,
        error: undefined,
        isStale: false,
      };

    case AnswerActionsEnum.ANSWERS_MARK_AS_STALE:
      return {
        ...state,
        isStale: true,
      };

    default:
      return state;
  }
}
